export const RESOURCE_TYPE_PERSON = "people";
export const RESOURCE_TYPE_EMAIL_ADDRESS = "email-addresses";
export const RESOURCE_TYPE_AFFILIATION_STATUS = "affiliation-statuses";
export const RESOURCE_TYPE_PARTICIPATION = "participations";

export const NEW_RESOURCE = null;
